import React, { useContext } from "react";
import styles from "./style.module.scss";
import { Link } from "react-router-dom";

//Assets
import AuthIcon from "components/shared/Icon/AuthIcon";
import MainLogo from "components/shared/Icon/MainLogo";
import Loading from "components/shared/Icon/Loading";

//Use Contexts
import { GlobalContext } from "state/global/globalContext";

const AuthMain = ({ title, buttonText, onClickButton, children, login, register, otp }) => {
    //Contexts
    const { error, loading } = useContext(GlobalContext);

    return (
        <div className={styles.mainAuth}>
            <div className={styles.mainAuth_container}>
                <MainLogo />
                <div className={styles.mainAuth_content}>
                    <div className={styles.mainAuth_header}>
                        <span>{title}</span>
                    </div>
                    <div className={styles.mainAuth_fields}>
                        {!otp && <AuthIcon />}
                        <div className={styles.mainAuth_input}>{children}</div>
                        <span className={styles.mainAuth_error}>{error}</span>
                        <button className={styles.mainAuth_button} onClick={onClickButton}>
                            {buttonText}
                            {loading && <Loading />}
                        </button>
                    </div>
                </div>
                {register && (
                    <Link to="/login">
                        <div className={styles.mainAuth_label__login}>
                            <div className={styles.mainAuth_label}>ورود به حساب کاربری</div>
                        </div>
                    </Link>
                )}
                {login && (
                    <Link to="/register">
                        <div className={styles.mainAuth_label__login}>
                            <div className={styles.mainAuth_label}>حساب کاربری ندارید؟</div>
                        </div>
                    </Link>
                )}
            </div>
            <div className="version">version 2.5.0</div>
        </div>
    );
};

export default AuthMain;
